//============================================================================
// Name        : TableColumnSimple.tsx
// Purpose     : Implement Edit Schedule Calencar view Day block
// Created     : 2019-08-19
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import React from "react";
import { connect } from "react-redux";
import { IUpdateStateAction } from "./actions/editScheduleActions";
import { EditScheduleActions, IReduxReducers } from "./types";

const leftBlueCell = css`
    background-color: #2770a8;
    color: #ffffff;
    padding: 5px 15px;
    text-align: left;
    font-size: 12px;
`;

const leftLightBlueCell = css`
    background-color: #8ab4d5;
`;

const columnScroll = css`
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 0 !important;
    }
`;

const headerStyle = css`
    text-align: center;
    height: 45px;
`;

export interface ITableColumnSimpleState {
    children: any;
    height?: number;
    width?: number;
    headerHeight: number;
    headerTitle: string;
    headerSubtitle?: string;
    footer: string;
}

class TableColumnSimple extends React.Component<ITableColumnSimpleState> {
    render() {
        const middleAlign = this.props.headerSubtitle ? {} : { display: "flex", alignItems: "center" };
        return (
            <React.Fragment>
                <div css={{ width: this.props.width ? this.props.width : "auto" }}>
                    <div css={[leftBlueCell, headerStyle, middleAlign]}>
                        {!this.props.headerSubtitle && this.props.headerTitle}
                        {this.props.headerSubtitle && <div>{this.props.headerTitle}</div>}
                        {this.props.headerSubtitle && <div>{this.props.headerSubtitle}</div>}
                    </div>

                    <div css={[columnScroll, { height: this.props.height }]}>
                    {/* <div> */}
                        {this.props.children}
                    </div>

                    <div css={[leftBlueCell, leftLightBlueCell]}>{this.props.footer}</div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReduxReducers) => ({
});

const mapDispatchToProps = dispatch => ({
    updateState: (newState: object) => dispatch({
        type: EditScheduleActions.UpdateState,
        payload: newState
    } as IUpdateStateAction)
});

export default connect(mapStateToProps, mapDispatchToProps)(TableColumnSimple);
